<template>
  <!-- 打たれた番号の表示エリア -->
  <div class="proned-passcode-area" :class="{ length7_8: length7_8 }">
    <input class="numberinput" type="text" v-model="displayCode[0]" readonly />
    <input class="numberinput" type="text" v-model="displayCode[1]" readonly />
    <input class="numberinput" type="text" v-model="displayCode[2]" readonly />
    <input class="numberinput" type="text" v-model="displayCode[3]" readonly />
    <input class="numberinput" type="text" v-model="displayCode[4]" readonly />
    <input class="numberinput" type="text" v-model="displayCode[5]" readonly />
    <input
      class="numberinput"
      v-if="length7_8"
      type="text"
      v-model="displayCode[6]"
      readonly
    />
    <input
      class="numberinput"
      v-if="length7_8"
      type="text"
      v-model="displayCode[7]"
      readonly
    />
    <button class="passcode-cancel-btn" @click="sliceEnd()">
      <img class="cancel-icon" src="@/assets/img/icon/svg/icon_backspace.svg" />
    </button>
  </div>
  <!-- 打たれた番号の表示エリア -->
</template>

<script>
import { computed } from "vue";

export default {
  name: "CodeInputDisplay",
  props: {
    code: {
      type: String,
    },
  },
  setup(props, context) {
    const sliceEnd = () => {
      context.emit("parentMethod");
    };

    const displayCode = computed(() => {
      return props.code;
    });

    const length7_8 = computed(() => {
      return props.code.length > 6;
    });

    return {
      sliceEnd,
      displayCode,
      length7_8,
    };
  },
};
</script>

<style lang="scss" scoped>
input {
  background-color: transparent;
  border-style: none;
}
.proned-passcode-area {
  margin: 6.41vh 0;
  font-size: 16px;
  height: 32px;
  position: relative;
  .numberinput {
    margin-right: 8%;
    width: 5%;
    text-align: center;
    color: #ffffff;
    vertical-align: middle;
    height: 32px;
    position: relative;
    top: -12px;
    font-size: 18px;
    padding: 0;
  }
  .passcode-cancel-btn {
    display: inline-block;
    height: auto;
    width: 13%;
    padding: 0;
    background: none;
    border: none;
  }
  img {
    margin-left: 0;
    height: 100%;
    width: 90%;
  }
}
.length7_8 {
  .numberinput {
    margin-right: 5%;
  }
}
</style>
